<template>
<layout-content>
  <template #headerTitle>
    <h1 class="layout-content-header-text">{{site ? site.name : ''}}{{editName}}</h1>

    <el-radio-group v-if="isShowRadio" v-model="type" size="small" style="margin-left: 10px;" @change="radioChange">
      <el-radio-button label="1">区域</el-radio-button>
      <el-radio-button label="2">分组</el-radio-button>
    </el-radio-group>
  </template>

  <template #toolbar>
    <el-button
      :disabled="!envConfig"
      type="primary"
      size="small"
      @click="onOpenEditor"
    >因子分组</el-button>
    <el-button
      :disabled="!envConfig"
      icon="el-icon-check"
      type="success"
      size="small"
      @click="onConfirmBtnClick"
    >确认</el-button>

    <el-button
      :disabled="!envConfig"
      type="danger"
      size="small"
      style="margin-left:0;"
      @click="onDeleteBtnClick"
    >删除</el-button>
  </template>

  <template #body>
    <div v-if="envConfig" class="env-chart-wrapper">
      <e-chart ref="env-chart" @initialized="onChartInitialized" />
    </div>

    <div v-else class="no-config-confirm-wrapper">
      <h2>当前站点没有动环配置需要确认</h2>
    </div>
  </template>
  <template #editor>
    <env-config-factor-editor
      ref="editor"
      :env-config="envConfig"
    />
  </template>
</layout-content>
</template>

<script>
import BaseListEditor from '../../BaseListEditor'
import EChart from '../../../components/Charts/ECharts'
import EnvConfigFactorEditor from './EnvConfigFactorEditor'

export default {
  name: 'EnvConfigListEdit',
  extends: BaseListEditor,
  components: {EChart, EnvConfigFactorEditor},
  props: {
    site: {
      required: true,
      type: Object
    },
    envConfig: {
      required: true
    }
  },
  data () {
    return {
      type: '1',
      envCategoryList: [],
      isShowRadio: false
    }
  },
  computed: {
    apiKey () {
      return 'EnvConfig'
    },
    idKey () {
      return 'mn'
    },
    editName () {
      return '动环配置确认'
    },
    envCategoryMap () {
      return this.envCategoryList.reduce((map, el) => {
        map[el.id] = el
        return map
      }, {})
    },
    tree () {
      let {envConfig, site} = this

      if (!envConfig) {
        return []
      }

      let {areas, areaFactors, factors} = JSON.parse(envConfig.json)
      if (this.type === '1') {
        let areaMap = areas.reduce((map, area) => {
          if (area.isDelete) {
            area.name = `${area.name}(已拆除)`
          }

          map[area.id] = area
          return map
        }, {})
        let factorMap = factors.reduce((map, factor) => {
          map[factor.id] = factor
          return map
        }, {})
        let roots = []
        let tmp = areaFactors.filter(areaFactor => factorMap[areaFactor.factorId]).sort((a, b) => factorMap[a.factorId].name.localeCompare(factorMap[b.factorId].name)).reduce((list, areaFactor) => {
          list.push({
            ...factorMap[areaFactor.factorId],
            parentId: areaFactor.areaId,
            label: {
              color: '#007ad0'
            }
          })

          return list
        }, [])

        tmp.push(...areas)

        for (let i = 0; i < tmp.length; i++) {
          let child = tmp[i]
          let {parentId} = child
          let parent = areaMap[parentId]

          if (parent) {
            let {children} = parent

            if (!children) {
              children = parent.children = []
              // tmp.push(parent)
            }

            children.push(child)
          } else {
            roots.push({
              ...child,
              label: {
                fontSize: 12
              }
            })
          }
        }

        return roots.length === 1 ? roots : [{
          id: site.id,
          name: site.name,
          label: {
            fontSize: 12
          },
          children: roots
        }]
      }

      let group = this.envCategoryList.reduce((map, el) => {
        map[el.id] = {
          id: el.id,
          name: el.name,
          label: {
            fontSize: 12
          },
          children: []
        }

        return map
      }, {})

      let newGroupMap = Object.assign(JSON.parse(JSON.stringify(group)), {
        noneGroup: {
          id: 'noneGroup',
          name: '未知分组',
          label: {
            fontSize: 12
          },
          children: []
        }
      })

      factors.sort((x, y) => x.name.localeCompare(y.name)).forEach(factor => {
        if (newGroupMap[factor.categoryId]) {
          newGroupMap[factor.categoryId].children.push({
            ...factor,
            label: {
              color: '#007ad0'
            }
          })
        } else {
          newGroupMap.noneGroup.children.push({
            ...factor,
            label: {
              color: '#007ad0'
            }
          })
        }
      })

      return [{
        id: site.id,
        name: site.name,
        label: {
          fontSize: 12
        },
        children: Object.values(newGroupMap).map(el => {
          if (el.children.length > 0) {
            return el
          }
        }).filter(Boolean)
      }]
    }
  },
  methods: {
    getEnvConfigs () {
      this.$api.EnvConfig.getList().then(envConfigs => {
        this.$parent.$parent.envConfigs = Object.freeze(envConfigs)
      }).catch(console.error)
    },
    getEnvFactorCategory () {
      this.$api.EnvFactor.getEnvFactorCategory().then(data => {
        this.envCategoryList = data
      }).catch(console.error)
    },
    radioChange () {
      this.render()
    },
    onConfirmBtnClick () {
      this.changeLoadStatus(true)
      this.$api.EnvConfig.reserve(this.envConfig.mn).then(() => {
        this.$emit('change')
        this.$store.dispatch('EnvFactor/request')

        this.$notify({
          title: '成功',
          message: '保留成功',
          type: 'success',
          position: 'bottom-right'
        })
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    onDeleteBtnClick () {
      this.$confirm(`此操作将永久删除当前站房上传的动环参数记录, 是否继续？`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        confirmButtonClass: 'confirm-dialog-confirm-btn',
        cancelButtonClass: 'confirm-dialog-cancel-btn',
        type: 'warning'
      }).then(() => {
        this.onDelete(this.envConfig)
      }).catch(() => {})
    },
    deleteSuccess () {
      this.$emit('change')
      this.$notify({
        title: '成功',
        message: '删除成功',
        type: 'success',
        position: 'bottom-right'
      })
    },
    render () {
      let {envConfig} = this
      let envChart = this.$refs['env-chart']
      if (!envChart) return

      if (!envConfig) {
        return envChart.clear()
      }

      envChart.setOpt({
        tooltip: {
          trigger: 'item',
          triggerOn: 'mousemove'
        },
        animation: false,
        series: [{
          type: 'tree',
          data: this.tree,
          top: '1%',
          left: '7%',
          bottom: '1%',
          right: '20%',
          symbolSize: 0,
          label: {
            position: 'left',
            verticalAlign: 'middle',
            align: 'right',
            fontSize: 10
          },
          leaves: {
            label: {
              position: 'right',
              verticalAlign: 'middle',
              align: 'left'
            }
          },
          expandAndCollapse: false,
          animationDuration: 550,
          animationDurationUpdate: 750
        }]
      })
    },
    onChartInitialized () {
      this.initialized = true
      this.render()
    },
    isShowRadioFn (envConfig) {
      if (!envConfig) {
        this.isShowRadio = false
        return
      }
      let {factors} = JSON.parse(envConfig.json)
      let data = factors.filter(el => el.categoryId)
      if (data.length > 0) {
        this.getEnvFactorCategory()
        this.isShowRadio = true
      } else {
        this.isShowRadio = false
      }
    }
  },
  watch: {
    envConfig (val) {
      this.isShowRadioFn(val)
      if (this.initialized) {
        this.render()
      }
    }
  },
  created () {
    this.isShowRadioFn(this.envConfig)
  }
}
</script>

<style lang="scss" scoped>
.env-chart-wrapper {
  height: 100%;
  overflow: auto;
}

.no-config-confirm-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/09System-Settings/01Site/EnvConfigListEdit.vue